// extracted by mini-css-extract-plugin
module.exports = {"imageHolder":"ArticleSavedScrollSelection_imageHolder__1yLKR","highlight":"ArticleSavedScrollSelection_highlight__1JCYH"};